import config from "../config";
import request from "./httpService";

const { apiHost, backendBaseURL } = config().secrets;

export async function kycSubmission(payload) {
	const url = `${backendBaseURL}/api/v1/user/kycSubmission`;
	const { data } = await request.post(url, payload);
	return data;
}

export async function getAllKycUpdateRequestSummaryIndividual() {
	const { data } = await request.get(
		`${backendBaseURL}/api/v1/admin/getAllKycUpdateRequestSummaryIndividual`
	);
	return data;
}

export async function getAllKycUpdateRequestSummaryCorporate() {
	const { data } = await request.get(
		`${backendBaseURL}/api/v1/admin/getAllKycUpdateRequestSummaryCorporate`
	);
	return data;
}

export async function getAllKycSubmissionRequestsSummary() {
	const { data } = await request.get(
		`${backendBaseURL}/api/v1/admin/getAllKycSubmissionRequestsSummary`
	);
	return data;
}

export async function getAllKycSubmission() {
	const { data } = await request.get(
		`${backendBaseURL}/api/v1/admin/getAllKycSubmission`
	);
	return data;
}

export async function getRequest(id) {
	const { data } = await request.get(
		`${backendBaseURL}/api/v1/admin/getRequest/${id}`
	);
	return data;
}

export async function getAllInitiatorIndividualKycUpdates() {
	const { data } = await request.get(
		`${backendBaseURL}/api/v1/admin/getAllInitiatorIndividualKycUpdates`
	);
	return data;
}

export async function getAllAuthorizerIndividualKycUpdates() {
	const { data } = await request.get(
		`${backendBaseURL}/api/v1/admin/getAllAuthorizerIndividualKycUpdates`
	);
	return data;
}

export async function getAllInitiatorCorporateKycUpdates() {
	const { data } = await request.get(
		`${backendBaseURL}/api/v1/admin/getAllInitiatorCorporateKycUpdates`
	);
	return data;
}

export async function getAllAuthorizerCorporateKycUpdates() {
	const { data } = await request.get(
		`${backendBaseURL}/api/v1/admin/getAllAuthorizerCorporateKycUpdates`
	);
	return data;
}

export async function approveInititorKycUpdateRequest(payload) {
	const url = `${backendBaseURL}/api/v1/admin/approveInititorKycUpdateRequest`;
	const { data } = await request.put(url, payload);
	return data;
}

export async function approveAuthorizerKycUpdateRequest(payload) {
	const url = `${backendBaseURL}/api/v1/admin/approveAuthorizerKycUpdateRequest`;
	const { data } = await request.put(url, payload);
	return data;
}

export async function rejectInititorKycUpdateRequest(payload) {
	const url = `${backendBaseURL}/api/v1/admin/rejectInititorKycUpdateRequest`;
	const { data } = await request.put(url, payload);
	return data;
}

export async function rejectAuthorizerKycUpdateRequest(payload) {
	const url = `${backendBaseURL}/api/v1/admin/rejectAuthorizerKycUpdateRequest`;
	const { data } = await request.put(url, payload);
	return data;
}

export async function sendOtp(payload) {
	const url = `${apiHost}/api/customer/send-admin-otp`;
	const { data } = await request.post(url, payload);
	return data;
}

export async function verifyOtp(payload) {
	const url = `${apiHost}/api/customer/verify-admin-otp`;
	const { data } = await request.post(url, payload);
	return data;
}

export async function ixtracKYCUpdates(payload) {
	const url = `${apiHost}/api/registrars/ixtracKYCUpdates`;
	const { data } = await request.post(url, payload);
	return data;
}

export async function uploadHolderDocuments(payload) {
	const url = `${apiHost}/api/registrars/uploadHolderDocuments`;
	const { data } = await request.post(url, payload);
	return data;
}

export async function deleteKycUpdateRequestsInitiator(payload) {
	const url = `${backendBaseURL}/api/v1/admin/deleteKycUpdateRequestsInitiator`;
	const { data } = await request.put(url, payload);
	return data;
}

export async function deleteKycUpdateRequestsAuthorizer(payload) {
	const url = `${backendBaseURL}/api/v1/admin/deleteKycUpdateRequestsAuthorizer`;
	const { data } = await request.put(url, payload);
	return data;
}
